import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Translation
import { MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';

// App root
import { AppComponent } from './app.component';

// App translations
import { appInitializerFactory, HttpLoaderFactory, MyMissingTranslationHandler } from './app-translations';

import { AppRoutingModule } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { SharedServicesModule } from './shared/shared-services.module';

import { PagesModule } from './pages/pages.module';

// Interceptors
import { LogInterceptor } from './shared/services/log.interceptor';
import { RouteInterceptor } from './shared/services/route.interceptor';
import { MatNativeDateModule } from '@angular/material';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { UserService } from './shared/services/user.service';

/**
 * Root module
 */
@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
    }),
    PagesModule,
    AppRoutingModule,
    SharedServicesModule,
    SharedModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector, UserService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RouteInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LogInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/app.module.ts